/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowRightTail = createReactComponent("arrow-right-tail", "IconArrowRightTail", [
  ["path", { d: "M18 15l3 -3l-3 -3", key: "svg-0" }],
  ["path", { d: "M3 15l3 -3l-3 -3", key: "svg-1" }],
  ["path", { d: "M6 12l15 0", key: "svg-2" }]
]);

export { IconArrowRightTail as default };
//# sourceMappingURL=IconArrowRightTail.js.map
